import { Link } from "react-router-dom"
import useAuthUser from "../hooks/useAuthUser";

export default function Header() {
    const { user, isLogged } = useAuthUser();
    const path = window.location.pathname;

    const logout = () => {
        localStorage.removeItem('authUser');
        window.location.href = '/';
    }
    
    return (
        <nav className="navbar navbar-expand-lg">
            <div className="container py-3">
                <a href="/#home" className="navbar-brand text-primary border border-2 border-primary px-3 rounded-pill fw-semibold">
                    Potential Lab
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a href="/#home" className="nav-link" aria-current="page">Beranda</a>
                        </li>
                        <li className="nav-item">
                            <a href="/#about" className="nav-link">Tentang Kami</a>
                        </li>
                        <li className="nav-item">
                            <a href="/#department" className="nav-link">Lembaga</a>
                        </li>
                        <li className="nav-item">
                            <a href="/#contact" className="nav-link">Kontak</a>
                        </li>
                        {isLogged ? (
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Pengaturan
                                </a>
                                <ul className="dropdown-menu">
                                    <li><a onClick={(e) => {
                                        e.preventDefault();
                                        logout();
                                    }} className="dropdown-item" href="#">Logout</a></li>
                                </ul>
                            </li>
                        ) : null}
                    </ul>
                </div>
            </div>
        </nav>
    )
}